<template>
  <div>
    <VcUpsellBlock mode="dialog"
                   :image-url="image"
                   :title-text="$t('payment.work_order_upgrade.title')"
                   :subtitle-text="$t('payment.work_order_upgrade.subtitle')"
                   :button-text="$t('payment.work_order_upgrade.button')"
                   icon="$check_circle_fill"
                   :bullets-text="bullets"
                   @buttonClick="goToUpgrade"/>
  </div>
</template>

<script>
export default {
  name: "WorkOrderUpgradePage",
  created() {
    this.$track('Work order upgrade dialog view');
  },
  computed: {
    image() {
      return require(`@/assets/images/work_order_upgrade_dialog.png`);
    },
    bullets() {
      return [
        this.$t('payment.work_order_upgrade.bullets.a'),
        this.$t('payment.work_order_upgrade.bullets.b'),
        this.$t('payment.work_order_upgrade.bullets.c')
      ]
    }
  },
  methods: {
    goToUpgrade() {
      this.$track('Work order upgrade CTA is clicked');
      this.$emit('close');
      this.$frontageApi.send('upgrade-action');
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
